import { FormItemProps } from '../../types';


const loadOptions = async (item: FormItemProps, inputValue: string, formData:any): Promise<any[]> => {
    const optionList:any[] = [];

    // Add existing options if available
    if (item.itemOptions?.list) {
        optionList.push(...item.itemOptions.list);
    }

    // Fetch additional options if fetch function is available
    if (item.itemOptions?.fetch) {
        try {
            const data:any = await item.itemOptions.fetch(inputValue, formData);
            optionList.push(...data);
        } catch (error) {
            console.error("Error fetching options: ", error);
        }
    }

    return optionList;
};

export default loadOptions;
